import { BG_CARD, BORDER_LIGHT, TEXT_DARK, TEXT_MUTED } from '../legacy-ball/table-management/designTokens';

interface Contributor {
  name: string;
  tilePurchase: boolean;
  article: boolean;
  adPurchase: boolean;
  reviewer: boolean;
}

interface ContributorsCardViewProps {
  contributors: Contributor[];
}

const BADGE_LABELS: { key: keyof Omit<Contributor, 'name'>; label: string }[] = [
  { key: 'tilePurchase', label: 'Tile Purchase' },
  { key: 'article', label: 'Article' },
  { key: 'adPurchase', label: 'Ad Purchase' },
  { key: 'reviewer', label: 'Reviewer' },
];

export function ContributorsCardView({ contributors }: ContributorsCardViewProps) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
      {contributors.map((contributor) => (
        <div
          key={contributor.name}
          style={{
            minWidth: 200,
            padding: 12,
            backgroundColor: BG_CARD,
            border: `1px solid ${BORDER_LIGHT}`,
            borderRadius: 8,
          }}
        >
          <div style={{ fontWeight: 600, color: TEXT_DARK, marginBottom: 6 }}>
            {contributor.name}
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {BADGE_LABELS.filter(({ key }) => contributor[key]).map(({ label }) => (
              <span
                key={label}
                style={{
                  fontSize: '0.75rem',
                  padding: '2px 6px',
                  borderRadius: 4,
                  backgroundColor: '#e8f5e9',
                  color: TEXT_MUTED,
                }}
              >
                {label}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
